import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MEDALS = ["🥇", "🥈", "🥉", "4", "5"];
const fmt = (a) => (a >= 10 ? `$${Math.round(a)}` : `$${a.toFixed(2)}`);

const TopWinners = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let dead = false;
    axios.get(`${API}/public/top-winners`).then((r) => { if (!dead) setData(r.data); }).catch(() => {});
    return () => { dead = true; };
  }, []);
  if (!data || (data.winners || []).length < 3) return null;
  return (
    <div data-testid="top-winners" className="flex flex-col">
      <div className="flex items-center gap-2 mb-4">
        <Crown className="w-4 h-4 text-[#F7B731]" />
        <h2 className="font-mono font-black tracking-[0.18em] text-[#F7B731] text-base md:text-lg">TOP WINNERS</h2>
        <span className="ml-auto font-mono text-[9px] text-white/35">{data.window} · real settled P&L</span>
      </div>
      <div className="h-[380px] overflow-y-auto rounded-2xl border border-white/10 bg-[#0d1119] p-3 space-y-2">
        {data.winners.map((w, i) => (
          <div key={i} data-testid={`top-winner-${i}`}
            className={`flex items-center gap-3 rounded-xl px-4 py-3 border ${i === 0
              ? "border-[#F7B731]/50 bg-[#F7B731]/8" : "border-white/8 bg-[#10141f]/80"}`}
            style={i === 0 ? { boxShadow: "0 0 18px rgba(247,183,49,.08)" } : undefined}>
            <span className={`w-8 text-center ${i < 3 ? "text-xl" : "font-mono font-black text-white/35 text-sm"}`}>{MEDALS[i]}</span>
            <div className="min-w-0 flex-1">
              <p className="font-mono font-black text-white text-sm truncate">{w.name}</p>
              <p className="font-mono text-[10px] text-white/40">{w.wins}/{w.plays} wins · best +{fmt(w.best)}</p>
            </div>
            <span className={`font-mono font-black text-lg ${i === 0 ? "text-[#F7B731]" : "text-[#089981]"}`}>+{fmt(w.total)}</span>
          </div>
        ))}
        <p className="font-mono text-[9px] text-white/35 text-center pt-1">
          net P&L from real settled contracts · names are pseudonyms unless publicly claimed
        </p>
      </div>
    </div>
  );
};

export default TopWinners;
